/**
 * Navigation management module
 * Inserts brand bar + bottom nav once; wires nav events.
 */

import headerHtml from '../components/Header/HeaderComponent.html';
import { stateManager } from './state-manager';
import { eventManager, showToast } from './ui-utils';

let headerInitialized = false;
const NAV_ID = 'app-nav';

export function initializeHeader(): void {
    if (headerInitialized) return;
    if (document.getElementById(NAV_ID)) {
        headerInitialized = true;
        stateManager.markHeaderInitialized();
        return;
    }

    // Insert brand bar + bottom nav at end of body
    document.body.insertAdjacentHTML('beforeend', headerHtml);

    // Keep the selected org in state for other components, but don't surface it in
    // the brand bar.
    const orgName = localStorage.getItem('SelectedOrganizationName') ||
                    localStorage.getItem('organizationName') || '';
    stateManager.setState({ organizationName: orgName });

    wireNavEvents();
    headerInitialized = true;
    stateManager.markHeaderInitialized();
}

function wireNavEvents(): void {
    eventManager.removeComponentListeners(NAV_ID);

    // My Reports
    const reportsBtn = document.getElementById('nav-my-reports');
    if (reportsBtn) {
        eventManager.addEventListener(NAV_ID, reportsBtn, 'click', () => {
            import('../components/ReportList/ReportListComponent')
                .then(mod => mod.showLandingView());
        });
    }

    // Create Report has no nav button — it is started from the New button on the
    // Reports tab (see ReportListComponent).

    // Import Data
    const importBtn = document.getElementById('nav-import');
    if (importBtn) {
        eventManager.addEventListener(NAV_ID, importBtn, 'click', async () => {
            stateManager.setActiveTab('export-data');
            const container = document.getElementById('component-container');
            if (!container) return;
            try {
                const { default: html } = await import('../components/ExportData/ExportDataComponent.html');
                container.innerHTML = html;
                const mod = await import('../components/ExportData/ExportDataComponent');
                if (mod.initializeExportDataComponent) mod.initializeExportDataComponent();
            } catch (err) {
                container.innerHTML = '<div style="color:red;padding:1rem;">Failed to load Import component.</div>';
                console.error('ExportDataComponent load error:', err);
            }
        });
    }

    // Sign Out
    const signoutBtn = document.getElementById('nav-signout');
    if (signoutBtn) {
        eventManager.addEventListener(NAV_ID, signoutBtn, 'click', async () => {
            try {
                const mod = await import('../components/Login/LoginComponent');
                await mod.signOut();
            } catch (err) {
                console.error('Sign out failed:', err);
                showToast('Unable to sign out. Please try again.', true);
            }
        });
    }
}

export function resetHeader(): void {
    const brand = document.getElementById('app-brand');
    const nav   = document.getElementById(NAV_ID);
    eventManager.removeComponentListeners(NAV_ID);
    brand?.remove();
    nav?.remove();
    headerInitialized = false;
}
